import { FC } from 'react';

import { LineType } from '../../enums/LineType';
import { OrderItem } from '../../interfaces/Order';

import OrderLineListItem from './OrderLineListItem';
import ServiceOrderListItem from './ServiceOrderListItem';

interface IOrderItemListProps {
  items: OrderItem[];
}

const OrderItemList: FC<IOrderItemListProps> = ({ items }) => {
  return (
    <ul className="OrderItemList" data-testid="orderItemList">
      {items.map((item, index) => {
        if (!item.orderLine) {
          return '';
        }

        const { itemNo, lineType } = item.orderLine;

        if (lineType === LineType.Item) {
          return <OrderLineListItem key={`${itemNo}-${index}`} item={item} />;
        } else if (lineType === LineType.Service) {
          return <ServiceOrderListItem key={`${itemNo}-${index}`} item={item} />;
        }

        return '';
      })}
    </ul>
  );
};

export default OrderItemList;
